<!-- <section id="st-intro">
    <div class="featured-slider" data-display="1,1,1,1" data-dot="on" data-nav="on" data-number="on" data-autoplay="on" data-interval="5000">
        <div class="slider-content"             >
            <div class="slider-wrapper row container">
                <ng-container *ngFor="let item of contentsBanner;">
                    <div class="col-12 slide item" style="width: 1919px;">
                        <a routerLink="{{ item.linkInfo }}">
                            <img src="{{ urlWownet + item.filePath + item.fileName }}" alt="{{ item.fileName }}" />
                        </a>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</section> -->

<!-- new style -->

<div class="mainContWrap">
  <!-- mainVisual -->
  <div class="mainVisual">
      <iframe width="100%" height="100%" 
      src="https://www.youtube.com/embed/E765lwSUQ_s?autoplay=1&mute=1&controls=0&loop=1&playlist=E765lwSUQ_s" title="" 
      frameborder="0" 
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
      referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
    <div class="mainVisLayer"></div>
  </div>
  <!-- //mainVisual -->

  <!-- mainProd -->
  <div class="mainProd" *ngIf="showMainProd">
    <h2 class="mainTit contain" data-aos="fade-right" data-aos-delay="200" data-aos-duration="800">Thejogak Technology
    </h2>
    <div class="mainProdSlide" data-aos="fade-left" data-aos-delay="200" data-aos-duration="1000">
      <div class="swiper-container">
        <div class="swiper-wrapper">
            <div class="swiper-slide">
                <a href="/company/tech/auto-tech">
                    <div class="imgWrap">
                        <img src="./assets/lasted/img/mainProd01.jpg" alt="" class="off">
                        <img src="./assets/lasted/img/mainProd01_on.jpg" alt="" class="on">
                    </div>
                    <dl>
                        <dt>Auto Tech</dt>
                        <dd>올인원테라피</dd>
                    </dl>
                </a>
            </div>
            <div class="swiper-slide">
                <a href="/company/tech/auto-tech">
                    <div class="imgWrap">
                        <img src="./assets/lasted/img/mainProd02.jpg" alt="" class="off">
                        <img src="./assets/lasted/img/mainProd02.gif" alt="" class="on">
                    </div>
                    <dl>
                        <dt>Auto Tech</dt>
                        <dd>피트니스돔</dd>
                    </dl>
                </a>
            </div>
            <!-- <div class="swiper-slide">
                <a href="#none">
                    <div class="imgWrap">
                        <img src="./assets/lasted/img/mainProd03.jpg" alt="" class="off">
                        <img src="./assets/lasted/img/mainProd03.gif" alt="" class="on">
                    </div>
                    <dl>
                        <dt>Auto Tech</dt>
                        <dd>온열반신돔</dd>
                    </dl>
                </a>
            </div> -->
            <div class="swiper-slide">
                <a href="/company/tech/nano-tech">
                    <div class="imgWrap">
                        <img src="./assets/lasted/img/mainProd03.jpg" alt="" class="off">
                        <img src="./assets/lasted/img/mainProd03.gif" alt="" class="on">
                    </div>
                    <dl>
                        <dt>Nano Tech</dt>
                        <dd>스킨스칼프</dd>
                    </dl>
                </a>
            </div>
            <div class="swiper-slide">
                <a href="/company/tech/smart-tech">
                    <div class="imgWrap">
                        <img src="./assets/lasted/img/mainProd04.jpg" alt="" class="off">
                        <img src="./assets/lasted/img/mainProd04.gif" alt="" class="on">
                    </div>
                    <dl>
                        <dt>A.I SMART TECH</dt>
                        <dd>더조각 A.I 바디스캐너</dd>
                    </dl>
                </a>
            </div>
            <div class="swiper-slide">
                <a href="/company/tech/bio-tech">
                    <div class="imgWrap">
                        <img src="./assets/lasted/img/mainProd05.jpg" alt="" class="off">
                        <img src="./assets/lasted/img/mainProd05.gif" alt="" class="on">
                    </div>
                    <dl>
                        <dt>Bio Tech</dt>
                        <dd>코스메틱</dd>
                    </dl>
                </a>
            </div>
            <div class="swiper-slide">
                <a href="/company/tech/bio-tech">
                    <div class="imgWrap">
                        <img src="./assets/lasted/img/mainProd06.jpg" alt="" class="off">
                        <img src="./assets/lasted/img/mainProd06.gif" alt="" class="on">
                    </div>
                    <dl>
                        <dt>Bio Tech</dt>
                        <dd>건강 식품</dd>
                    </dl>
                </a>
            </div>
            <div class="swiper-slide">
                <a href="/company/tech/edu-tech">
                    <div class="imgWrap">
                        <img src="./assets/lasted/img/mainProd07.jpg" alt="" class="off">
                        <img src="./assets/lasted/img/mainProd07.gif" alt="" class="on">
                    </div>
                    <dl>
                        <dt>Edu Tech</dt>
                        <dd>교육</dd>
                    </dl>
                </a>
            </div>
        </div>
      </div>
    </div>
  </div>
  <!-- //mainProd -->
</div>

<!-- <div class="mainSlideWrap">
  <div class="mainVisual">
    <div class="swiper-container">
      <ul class="swiper-wrapper">
        <li class="swiper-slide " *ngFor="let item of contentsBanner; let i = index">
          <a routerLink="{{ item.linkInfo }}">
            <div>
              <img src="{{ item.pathUrl  }}"  alt="{{ item.fileName }}" >
            </div>
          </a>
        </li>
      </ul>
      <div class="swiper-button-next"></div>
      <div class="swiper-button-prev"></div>
    </div>
  </div>
</div> -->